import { Fragment, useEffect, useState } from "react";

import { Icon } from "@/components/Icon";

interface TopbarProps {
  crumbs: string[];
}

function pad(n: number) {
  return String(n).padStart(2, "0");
}

export function Topbar({ crumbs }: TopbarProps) {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const hh = pad(time.getUTCHours());
  const mm = pad(time.getUTCMinutes());
  const ss = pad(time.getUTCSeconds());

  return (
    <div className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={`${c}-${i}`}>
            {i > 0 && <span className="crumbs__sep">/</span>}
            <span className={i === crumbs.length - 1 ? "crumbs__last" : ""}>{c}</span>
          </Fragment>
        ))}
      </div>
      <div className="topbar__spacer" />
      <div className="topbar__coord">
        <span>
          <Icon.Compass style={{ width: 14, height: 14, opacity: 0.7 }} /> <b>WGS-84</b>
        </span>
        <span>
          UTC <b>{hh}:{mm}:{ss}</b>
        </span>
        <span>
          caster.amelia.am
          <b style={{ marginLeft: 6, color: "var(--accent-deep)" }}>:2101</b>
        </span>
      </div>
    </div>
  );
}
